import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { useNavigate, useLocation } from 'react-router';
import styled from '@emotion/styled';
import { Chip, ChipsList } from '@naf-simba/elements-chips';
import { Check } from '@naf-simba/building-blocks-icons/General';
import { useHandleNafLocationsRoutes } from '../useHandleNafLocationsRoutes';

export type Location = 'lokalavdelinger' | 'mc-klubb' | 'naf-senter' | 'ovingsbaner' | 'arrangementer';

const LocationChips = () => {
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const { locations, name: nafLocationName } = useHandleNafLocationsRoutes();
  const currentLocation = Object.values(locations).find((location) =>
    routerLocation.pathname.includes(location.fullUrl),
  );
  if (!currentLocation || routerLocation.pathname.split('/').length > 3) return null;
  const selectedChip = currentLocation.slug;
  return (
    <>
      <Text variant={TextVariant.Header1}>{nafLocationName}</Text>
      <ChipsWrapper>
        {Object.values(locations).map(({ name, slug, fullUrl }) => (
          <Chip
            key={slug}
            label={name}
            onClick={() => navigate(fullUrl)}
            variant={slug === selectedChip ? 'filled' : 'outlined'}
            color="primary"
            startIcon={slug === selectedChip ? Check : undefined}
          />
        ))}
      </ChipsWrapper>
    </>
  );
};

const ChipsWrapper = styled(ChipsList)`
  display: flex;
  @media (max-width: ${breakpoints.m}) {
    flex-wrap: wrap;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none; // for Firefox
    ::-webkit-scrollbar {
      display: none; // for Chrome, Safari and Opera
    }
    > * {
      display: flex;
      flex: none;
    }
    margin-left: -${spacing.space24};
    margin-right: -${spacing.space24};
    padding-left: ${spacing.space24};
    padding-right: ${spacing.space24};
  }
`;

export default LocationChips;
